import {
  Box, Flex, ModalContentProps, Text,
  useToast,
} from '@chakra-ui/react';

import { CreateApplicantForm } from './CreateApplicantForm';
import { truefileServerApi } from 'api/truefilesServerApi';
import { ICreateApplicantRequest } from 'api/types/trueFileServerTypes';
import { ModalFrame } from 'components/modal/ModalFrame';
import useApplicationContext from 'contexts/application/useApplicationContext';

const content: ModalContentProps = {
  maxW: '800px',
  minW: '720px',
  marginTop: 50,
};

export interface IChromeSecurityNoticeProps {
  isOpen: boolean;
  onClose: ()=> void;
  onNext: ()=> Promise<void>;
}
export function CreateApplicantModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean,
  onClose: ()=> void,
}): JSX.Element {
  const toast = useToast();
  const { application, refetchApplication } = useApplicationContext();
  const Header = (
    <Box fontSize='35px' borderRadius='10px' padding='0px' width='100%' marginBottom='0px'>
      <Flex direction='row' gap='10px'>
        <Text>Add an applicant:</Text>
      </Flex>
    </Box>
  );

  async function onSubmit({
    firstName, lastName, sin, middleName,
  }: ICreateApplicantRequest): Promise<void> {
    await truefileServerApi.POST('/api/applicants', {
      body: {
        firstName,
        lastName,
        middleName,
        sin: Number(sin),
        applicationId: application.id!,
      },
    });

    void refetchApplication();

    toast({
      title: 'Success',
      description: 'Applicant Created\'',
      status: 'success',
      duration: 5000,
      position: 'top',
      isClosable: true,
    });

    onClose();
  }

  return (
    <ModalFrame
      hasCloseButton
      style={{ content }}
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      header={Header}
    >
      <CreateApplicantForm onSubmit={onSubmit} />
    </ModalFrame>
  );
}
